<template>
  <div class="apply_electronic">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="security_main_body_div_H1">市场调查</div>
          <div class="security_main_body_div_text">
            通过奇迹ip拓展全球视野，获得准确的市场研究数据，分析行业动态和竞争态势，帮助您在竞争激烈的市场中取得成功
          </div>
          <div class="security_main_body_div_butts">
            <div class="security_main_body_div_butt div_buttA" @click="loginshow">免费试用</div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">产品价格</div>
          </div>
          <div class="apply_electronic_dzsw_d4">
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon1.svg"
                alt=""
              />
              <div>全球地区覆盖</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon2.svg"
                alt=""
              />
              <div>自定义代理时效</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon3.svg"
                alt=""
              />
              <div>定位国家/州/城市IP</div>
            </div>
            <div>
              <img
              style="width: 60px;"
                src="http://apiupss.ppfly.top/images/banner_icon6.png"
                alt=""
              />
              <div>HTTP(S)/Socks5协议</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  深度洞察全球市场
                </div>
                <div class="security_main_body_divB_div_left_text">
                  挖掘市场研究的关键信息，准确预测市场变化趋势并提升竞争优势
                </div>
              </div>
              <div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>拓展全球视野</div>
                    <div class="applyele_list_img_text">
                      整合全球市场的行业数据，分析自身及竞争品牌的市场占有率，制定有效的市场策略
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>提升用户体验</div>
                    <div class="applyele_list_img_text">
                      通过分析市场数据了解客户需求，优化产品和服务，提升用户体验和满意度
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>收集用户反馈</div>
                    <div class="applyele_list_img_text">
                      轻松收集来自各大社媒平台的用户反馈和评价，了解客户情绪，提升用户认可度和品牌形象
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img
                src="http://apiupss.ppfly.top/images/introduce_r_3.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <apply_electronic_mainket />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_mainket from "@/components/apply_electronic_mainket/apply_electronic_mainket.vue";
export default {
  // apply-market
  name: "apply_market",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_mainket,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay(){
      this.$router
          .push({
            path: "/pay",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {

  },
  mounted() {
    this.totop()
  },
};
</script>
<style lang="scss" scoped>
.security_main_body{
  background-color: #f5f2f23a;
}
.security_main_body_div {
  background: url(http://apiupss.ppfly.top/images/buy-banner.bb39d3b.png);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1 {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
  max-width: 865px;
  margin: 31px auto 0;
}
.apply_electronic_dzsw_d4 {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.apply_electronic_dzsw_d4  img{
  margin-bottom: 30px;
}
.security_main_body_div_butts {
  display: flex;
  justify-content: center;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB {
  margin-top: 200px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 7px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
